<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="table"/>
      <template v-else>
        <template v-if="usagesList.length">
          <v-data-table :headers="headers" :items="usagesList" mobile-breakpoint hide-default-footer hide-default-header disable-sort>
            <!-- header -->
            <template v-slot:[`header`]="{ props: { headers } }">
              <VTableHeaders :headers="headers" />
            </template>
            <!-- end header -->
            <template v-slot:[`item.customer`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.subscription_line.subscription_customer_name}}</span>
            </template>
            <template v-slot:[`item.plan`]="{item}">
              {{item.subscription_line.plan_name}}
            </template>
            <template v-slot:[`item.creation_scheme`]="{item}">
              <v-chip color="lightBlue" text-color="primary" small>
                <template v-if="item.creation_scheme === 'file'"><v-icon left size="18">mdi-database-import</v-icon>Importación</template>
                <template v-else-if="item.creation_scheme === 'api'"><v-icon left size="18">mdi-code-greater-than</v-icon>Integración</template>
                <template v-else><v-icon left size="18">mdi-database</v-icon>Importación</template>
              </v-chip>
            </template>
            <template v-slot:[`item.quantity`]="{item}">
              <span class="text--secondary font-weight-medium">{{item.quantity}}</span>
            </template>
            <template v-slot:[`item.date_time`]="{item}">
              {{item.date_time | dateTime}}
            </template>
            <template v-slot:[`item.actions`]="{item}">
              <v-menu close-on-click close-on-content-click offset-y left :nudge-bottom="10" transition="slide-y-transition">
                <template v-slot:activator="{on, attrs}">
                  <v-btn class="ml-2" v-bind="attrs" v-on="on" min-width="34" max-width="34" outlined color="secondary" :ripple="false" retain-focus-on-click><v-icon color="secondary">mdi-dots-horizontal</v-icon></v-btn>
                </template>
                <v-list class="pa-0">
                  <v-list-item class="px-5 py-1" :to="{ name: 'SubscriptionRetrieve', params: { id: item.subscription_line.subscription_id } }" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Ir a la suscripción</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-5 py-1" :to="{ name: 'CustomerRetrieveUpdate', params: { id: item.subscription_line.subscription_customer_id } }" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Ir al cliente</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-5 py-1" :to="{ name: 'PlanRetrieveUpdate', params: { id: item.subscription_line.plan_id } }" :ripple="false">
                    <v-list-item-title class="subtitle-2 font-weight-medium">Ir al plan</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
          <v-divider />
          <v-row class="mx-0" align="center">
            <v-col cols="6">
              <span class="body-2 text--secondary">{{count}} registros</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-pagination v-model="page" :length="totalPages" total-visible="6" />
            </v-col>
          </v-row>
        </template>
        <v-sheet class="py-8 text-center" v-else>
          <v-icon class="d-block" color="secondary" size="70">mdi-playlist-remove</v-icon>
          <span class="d-block subtitle-1">No existen registros de uso</span>
        </v-sheet>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'

// components
import VTableHeaders from '../../components/VTable/VTableHeaders'

// mixins
import ListViewMixin from '../../mixins/ListViewMixin'

export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Cliente', value: 'customer' },
      { text: 'Plan', value: 'plan' },
      { text: 'Canal', value: 'creation_scheme', width: 180 },
      { text: 'Cantidad', value: 'quantity', width: 120, align: 'end' },
      { text: 'Marca de tiempo', value: 'date_time', width: 160, align: 'end', sortable: true },
      { text: '', value: 'actions', width: 80, align: 'end' }
    ]
  }),
  computed: mapState({
    count: state => state.subscriptions.usagesCount,
    usagesList: state => state.subscriptions.usagesList
  })
}
</script>
